var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortAnalytic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 8.83222 17.9954 8.66551 17.9863 8.5C17.736 3.92752 14.0725 0.264032 9.5 0.0136542C9.33449 0.00459099 9.16778 0 9 0C8.83222 0 8.66551 0.00459099 8.5 0.0136542C3.76201 0.273095 0 4.19722 0 9C0 13.9706 4.02944 18 9 18C13.8028 18 17.7269 14.238 17.9863 9.5C17.9954 9.33449 18 9.16778 18 9ZM16.9846 8.5C16.7367 4.47999 13.52 1.26327 9.5 1.01537V8.5H16.9846ZM8.5 8.79289V1.01537C4.31463 1.27347 1 4.74965 1 9C1 11.0292 1.75551 12.882 3.00058 14.2923L8.5 8.79289ZM3.70769 14.9994C5.11804 16.2445 6.97079 17 9 17C13.2504 17 16.7265 13.6854 16.9846 9.5H9.20711L3.70769 14.9994Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortAnalytic);
export default __webpack_public_path__ + "static/media/short-analytic.b3543c8a6089cf69e33efa3681634086.svg";
export { ForwardRef as ReactComponent };